export default {
  login_mfa: {
    title: '@:login.title',
    message: '已將認證碼寄送至登錄電話號碼的SMS。\n請輸入認證碼後按下登入鍵。\n有效期限為5分鐘。',
    button_submit: '@:login.login',
    button_resend: '重傳認證碼',
    alert_success: '已重傳認證碼。',
    alert_error: '認證碼重傳失敗。',
    error: '@:common.error.code_9999',
    no_phone_number_message: '由於登入的使用者並未登錄電話號碼，因此無法實施SMS驗證。\n\n請聯絡貴公司的帳號管理人，要求登錄電話號碼。',
  },
}
